import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/shared/auth.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  showNavBar : boolean
  isLoading = true;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
    ) { }

  ngOnInit(): void {
    
    const currentUser = this.authenticationService.getcurrentUser();

    if(this.authenticationService.currentUserValue){
      this.showNavBar = true;
    }else{
      this.showNavBar = false;
    }
    this.isLoading=false;
    // currentUser.subscribe(token => {
    //   debugger
    //   console.log(token,'ss')
    //   if(token){
    //     this.showNavBar = true
    //   }else{
    //     this.showNavBar = false
    //   }
    //   this.isLoading=false;
    // })
  
  }

}
